import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantUserRolesQuery(userId: string | undefined) {
  const { user } = useAuth();

  return useQuery({
    queryKey: tenantQueryKeys.userRoles(userId ?? ''),
    enabled: Boolean(user) && Boolean(userId),
    queryFn: () => {
      if (!userId) {
        throw new Error('Missing user id');
      }
      return userService.getUserRoles(userId);
    },
  });
}
